
 /**
 * @desc 文件上传进度条
 */
import CProgress from './CProgress'

export default CProgress;